import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import ActionsDropdown from "../ActionsDropdown";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

import { useParams } from "react-router-dom";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Walkin() {
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState([]);
  const [showCallbackDate, setShowCallbackDate] = useState(false);
  const [Updateshow, setUpdateShow] = useState(false);

  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: {
        _id: item.branch_id?._id ?? null,
        branch_name: item.branch_id?.branch_name ?? "",
      },
      student_name: item.student_name,
      mobile_no: item.mobile_no,
      email: item.email,
      Prefered_course: item.Prefered_course,
      course_id: item.course_id,
      Enquiry_date: item.Enquiry_date,
      Source_type: item.Source_type,
      contact_type: item.contact_type,
      assign_staff: item.assign_staff,
      referal_candidate_name: item.referal_candidate_name,
      referal_candidate: item.referal_candidate,
      followups_time: item.followups_time,
      followups_date: item.followups_date,
      status_date: item.status_date,
      status_time: item.status_time,
      followups_status: item.followups_status,
      followups_notes: item.followups_notes,
      interest: item.interest,
      qualification: item.qualification,
    }));
  }, [responseData]);
  const columns = useMemo(() => {
    // Get localStorage value
    const storedBranch = localStorage.getItem("branch_name");
    const showBranchColumn = storedBranch === "Branches";

    // Base columns (without Branch)
    const baseColumns = [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => row.index + 1,
      },
      // Other columns...
      {
        Header: "Name",
        accessor: "student_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Mobile",
        accessor: "mobile_no",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      // ... (all other columns except Branch)
    ];

    // Insert Branch column only if condition is met
    if (showBranchColumn) {
      baseColumns.splice(1, 0, {
        // Insert at position 1 (after S.No)
        Header: "Branch",
        accessor: "branch_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => value?.branch_name || "",
      });
    }

    // Add remaining columns (like Status, Last Date, etc.)
    baseColumns.push(
      {
        Header: "Course",
        accessor: "Prefered_course",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Source",
        accessor: "Source_type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Notes",
        accessor: "followups_notes",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Last Date",
        accessor: "followups_date",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          if (!value) return "";
          const date = new Date(value);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
      },
      {
        Header: "Status",
        accessor: "followups_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        width: 120,
        Cell: ({ value }) => {
          const statusClass = getStatusLabelClass(value);
          return (
            <span
              className={statusClass}
              style={{
                display: "inline-block",
                width: "120px",
                height: "20px",
                lineHeight: "15px",
                textAlign: "center",
              }}
            >
              {value}
            </span>
          );
        },
      }
    );

    return baseColumns;
  }, []); // Add dependencies if needed

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    fetchData();
    gettoken();
    getprevillages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { url_branch_name } = useParams(); // Extract "id" from URL

  // async function fetchData() {
  //   setLoading(true);
  //   const resposponseData = await axios.get(apiUrl + "/walkinleads", {
  //     params: { data: localStorage.getItem("branch_id") },
  //   });
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);
  //   setResponseData(resposponseData.data.reverse());
  //   console.log("Walkin leads : ", resposponseData.data);
  //   if (url_branch_name) {
  //     console.log("The url_branch_name is : ", url_branch_name);
  //     const filter_data = resposponseData.data.filter((data) => data.branch_id.branch_name == url_branch_name)
  //     // const filter_data = resposponseData.data.filter((data)=> data.branch_id.branch_name.toLowerCase() == url_branch_name)
  //     console.log("the filter_data is : ", filter_data.reverse());
  //     setResponseData(filter_data.reverse());
  //   }
  //   else {
  //     console.log("There was no url_branch_name");
  //   }
  // }

  async function fetchData() {
    setLoading(true);
    const resposponseData = await axios.get(apiUrl + "/walkinleads", {
      params: { data: localStorage.getItem("branch_id") },
    });
    console.log("asdffasd", resposponseData);
    setTimeout(() => {
      setLoading(false);
    }, 1000);

    const username = localStorage.getItem("username");
    const internal_emp = localStorage.getItem("internal_emp");
    const branch_name = localStorage.getItem("branch_name");
    console.log("the brnafdasfd", branch_name);
    if (branch_name === "Branches") {
      if (resposponseData && resposponseData.data) {
        const data = resposponseData.data;
        setResponseData(data.reverse());
        console.log("Walkin leads : ", resposponseData.data);
      }
    } else {
      const responsess = await axios.get(apiUrl + "/staff", {});

      const filteredDatassss = responsess.data.filter(
        (item) => item.empid === username || item.empid === internal_emp
      );
      console.log("Final Filtered Data:responsess", filteredDatassss);

      console.log("Final Filtered Data:called", resposponseData.data);
      console.log("Final Filtered Data:username", username);
      const filteredDatased = resposponseData.data.filter(
        (item) => item.assign_staff === filteredDatassss[0]?._id
      );
      console.log("Final Filtered Data:responsess`1`112", filteredDatased);
      setResponseData(resposponseData.data);
    }

    // ======== code to filter the based on selected branch =================
    if (url_branch_name) {
      console.log("The url_branch_name is : ", url_branch_name);

      const filter_data = resposponseData.data.filter(
        (data) => data.branch_id.branch_name == url_branch_name
      );
      // const filter_data = resposponseData.data.filter((data)=> data.branch_id.branch_name.toLowerCase() == url_branch_name)
      console.log("the filter_data is : ", filter_data.reverse());
      setResponseData(filter_data.reverse());
    } else {
      console.log("There was no url_branch_name");
    }
  }

  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      setroleid(response.data.detail.rolename);
      localStorage.setItem("role_id", response.data.detail.rolename);
      const id = response.data.detail.rolename;
      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const updateinfo = (_id) => {
    navigate(`/Leadhistroy/${_id}`);
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "Walkin-Details"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  // the pagination ---------------------------------------------------------------------

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  const [firstTime, setFirstTime] = useState(null);
  const [lasttimess, setLastTime] = useState(null);
  const [timeDifference, setTimeDifference] = useState(null);

  const [UpdatedData, setUpdatedData] = useState([]);

  const handleUpdated = async (_id, data) => {
    const currentTimes = new Date().toLocaleTimeString();

    console.log(`Current Time: ${currentTimes}`);
    setFirstTime(currentTimes);

    console.log("this", _id);
    console.log("this data", data);
    const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);
    console.log(filterUpdateData.data?.[0], "filterUpdateData___999");
    setUpdatedData(filterUpdateData.data?.[0]);

    // Set the formatted time to state

    setUpdateShow(true);
  };

  const handleupdatesubmit = async (id) => {
    try {
      const lasttimess = new Date().toLocaleTimeString("en-US", {
        hour12: true,
      });
      console.log(`End Time: ${lasttimess}`);
      setLastTime(lasttimess);
      // Set the start time manually for demonstration
      // This should come from your state or variable
      console.log(`Start Time: ${firstTime}`);

      // Convert both times to Date objects using the Date constructor
      const firstTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(firstTime)}Z`
      );
      const lastTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(lasttimess)}Z`
      );

      // Calculate the time difference in milliseconds
      const timeDifferenceInMillis = lastTimeDate - firstTimeDate;

      const timeDifferenceInSeconds = timeDifferenceInMillis / 1000;

      console.log(`Time difference: ${timeDifferenceInSeconds} seconds`);

      // Set the time difference to state (or variable)
      setTimeDifference(timeDifferenceInSeconds);

      // console.log("Time difference: ${timeDifferenceInSeconds} seconds",timeDifference);
      console.log(
        `Time difference: ${timeDifferenceInSeconds} seconds ${timeDifference}`
      );

      // Function to convert 12-hour time format (AM/PM) to 24-hour format
      function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes, seconds] = timePart.split(":");

        if (modifier === "PM" && hours !== "12") hours = parseInt(hours) + 12;
        if (modifier === "AM" && hours === "12") hours = "00";

        return `${hours}:${minutes}:${seconds}`;
      }
      console.log("schudule updateeeee ", timeDifference);

      let updateDatas;
      // Check if the followups_status is "converted"
      if (UpdatedData.followups_status === "Converted") {
        console.log("hiiii");

        // Update the state and prepare updateDatas in one step
        const updatedData = {
          ...UpdatedData,
          followups_status: "Walkin",
          followups_date: new Date(),
          duration_time: timeDifference, // Correctly get the current date
        };

        // Create updateDatas with the updated state
        updateDatas = {
          branch_id: updatedData.branch_id,
          student_name: updatedData.student_name,
          mobile_no: updatedData.mobile_no,
          email: updatedData.email,
          Source_type: updatedData.Source_type,
          referal_candidate: updatedData.referal_candidate || "",
          referal_candidate_name: updatedData.referal_candidate_name || "",
          Enquiry_date: updatedData.Enquiry_date,
          Prefered_course: updatedData.Prefered_course,
          followups_date: updatedData.followups_date,
          status_time: updatedData.status_time,
          followups_status: updatedData.followups_status,
          followups_notes: updatedData.followups_notes,
          qualification: updatedData.qualification,
          duration_time: timeDifferenceInSeconds,
          start_time: firstTime,
          end_time: lasttimess,
        };

        // Now you can use updateDatas as needed

        setUpdatedData(updateDatas); // Update the state

        if (UpdatedData.followups_status === "Converted") {
          // navigate(`/Registration/${id}`);
          navigate(`/Registration/${id}`, {
            state: { updatedData: UpdatedData },
          });
        }
      } else {
        ///////
        try {
          setLoading(true);
          console.log("The console update data as is : ", updateDatas, id);
          const response = await axios.put(
            apiUrl + `/leadsS/${id}`,
            UpdatedData
          );
          console.log("the response : ", response);

          const student_Id = response.data._id;
          console.log("the history update post", student_Id);
          const formDataaa = {
            student_Id: student_Id,
            Source_type: "",
            Enquiry_date: "",
            contact_type: UpdatedData.contact_type,
            assign_staff: UpdatedData.assign_staff,
            notes: UpdatedData.followups_notes,
            status: UpdatedData.followups_status,
            duration_time: timeDifferenceInSeconds,
            start_time: firstTime,
            end_time: lasttimess,
          };

          if (response.status === 200) {
            const response12 = await axios.post(
              apiUrl + "/leadhistroy",
              formDataaa
            );
            console.log("the history follow-up", response12);

            fetchData();
            toast.success("Converted successfully!");
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            setUpdateShow(false);
            // if (UpdatedData.followups_status === "converted") {
            //   // navigate(`/Registration/${id}`);
            //   navigate(`/Registration/${id}`, { state: { updatedData: UpdatedData } });
            // }
          } else {
            toast.error("Failed to convert!");
          }
        } catch { }

        //  ///////
      }

      console.log("checking data is fine", UpdatedData);
      console.log(id, "idddss");

      // try {
      //   console.log("The console update data as is : ", updateDatas, id);
      //   const response = await axios.put(apiUrl + `/leads/${id}`, UpdatedData);
      //   console.log("the response : ", response);

      //   const student_Id = response.data._id;
      //   console.log("the history update post", student_Id);
      //   const formDataaa = {
      //     student_Id: student_Id,
      //     Source_type: "",
      //     Enquiry_date: "",
      //     contact_type: UpdatedData.contact_type,
      //     assign_staff: UpdatedData.assign_staff,
      //     notes: UpdatedData.followups_notes,
      //     status: UpdatedData.followups_status,
      //     duration_time:duraton
      //   };

      //   if (response.status === 200) {
      //     const response12 = await axios.post(
      //       apiUrl + "/leadhistroy",
      //       formDataaa
      //     );
      //     console.log("the history follow-up", response12);

      //     fetchData();
      //     toast.success("Converted successfully!");
      //     setUpdateShow(false);
      //     if (UpdatedData.followups_status === "converted") {
      //       // navigate(`/Registration/${id}`);
      //       navigate(`/Registration/${id}`, { state: { updatedData: UpdatedData } });
      //     }
      //   } else {
      //     toast.error("Failed to convert!");
      //   }
      // }

      // catch (error) {
      //   toast.error("Error in conversion!");
      //   console.log("Error fetching data:", error.message);
      // }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  // Helper function to format ISO date to YYYY-MM-DD
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  function handalefollowupsStatus(e) {
    setUpdatedData({ ...UpdatedData, followups_status: e.target.value });
  }

  function interstedHandel(e) {
    console.log(e.target.value);

    setUpdatedData((prevData) => ({
      ...prevData,
      interest: e.target.value,
    }));
  }

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "Unqualified":
        return "bg-danger1 text-white1";
      case "Reachable":
        return "bg-secondary1 text-white1";
      case "Converted":
        return "bg-warning1 text-black1"; // Assuming black text for "converted"
      case "Rescheduled":
        return "bg-primary1 text-white1";
      case "Walkin":
        return "bg-success1 text-white1";
      case "NotReachable":
        return "bg-dark1 text-white1";
      case "Scheduled":
        return "bg-info1 text-white1";
      case "New":
        return "bg-dark1 text-white1";
      case "Walk-in-reschedule":
        return "bg-dark1 text-white1";
      default:
        return "";
    }
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false);
  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div>
        <div className="top">
          <div className="" style={{ marginTop: "-80px" }}>
            <div className="row mb-3">
              <div className="col-lg-11">
                <Link to="/dashboard" className="text-secondary dashBoard_text">
                  <b>Dashboard / </b>
                </Link>
                <Link to="#" className="text-secondary dashBoard_text">
                  <b>Leads / </b>
                </Link>
                <Link to="" className="text-danger dashBoard_text">
                  <b>Walkin</b>
                </Link>
                {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
              </div>
            </div>
          </div>


          {/* /////////////////////////////////////////////////////////////////// */}

          <div className="mb-1 mt-3">
            <div className="row">
              <div className="col-lg-7 col-md-4 col-sm-1">
                <div>
                  <h5 className="mt-2">Walkin </h5>
                </div>
              </div>
              <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

                {/* </div>

              <div className="col-lg-3 col-md-4 col-sm-7"> */}
                <div className="w-full flex-1 me-5">
                  <form>
                    <div className="relative">
                      <input
                        className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                        placeholder="Search ..."
                        type="search"
                        value={state.globalFilter || ""} // Use the globalFilter value
                        onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                      />
                    </div>
                  </form>
                </div>
                <div className="d-flex me-2">
                  <label className="form-label text-dark mt-1">Show : </label>
                  <div>
                    <select
                      className="form-control w-100 mx-2"
                      value={state.pageSize}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "All") {
                          setPageSize(data.length); // 'data' should be your dataset containing all the entries
                        } else {
                          setPageSize(Number(value));
                        }
                      }}
                    >
                      <option value="All">All</option> {/* Add 'All' option */}
                      {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                          {pageSize}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* //////////////////////////////////////////////////////////////////////////////////// */}

          <Table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <Th
                      {...column.getHeaderProps(
                        column.getSortByToggleProps()
                      )}
                    >
                      <div className="d-flex">
                        <div className="mx-2">{column.render("Header")}</div>
                        <div>
                          {column.canFilter ? column.render("Filter") : null}
                        </div>
                        <div className="mx-1">
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </div>
                      </div>
                    </Th>
                  ))}
                  <Th className="text-center">Action</Th>
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                    ))}
                    <Td className="text-center">
                      <ActionsDropdown
                        row={row.original}
                        permissions={{
                          edit: previllages.edit,
                          delete: previllages.delete,
                        }}
                        onEdit={(id, row) =>
                          handleUpdated(id, row)
                        }
                        onInfo={(id) => {
                          setLoading(true);
                          setTimeout(() => {
                            updateinfo(id);
                            setLoading(false);
                          }, 1000);
                        }}
                      />
                    </Td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        <Modal show={Updateshow} onHide={() => setUpdateShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti"> Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}
            <div className="row">
              <div className="col-lg-12 ">
                <div className=" p-2 pb-0">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            disabled
                            value={UpdatedData.student_name}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                student_name: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.student_name ? "filled" : ""}
                          >
                            Name
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.mobile_no}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                mobile_no: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.mobile_no ? "filled" : ""}
                          >
                            Mobile No
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.Prefered_course}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Prefered_course: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={
                              UpdatedData.Prefered_course ? "filled" : ""
                            }
                          >
                            Prefered Course
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            placeholder=""
                            value={UpdatedData.Source_type}
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Source_type: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.Source_type ? "filled" : ""}
                          >
                            Source_type
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="floating-label">
                          <select
                            className="form-control"
                            value={UpdatedData.followups_status || ""}
                            onChange={(e) => handalefollowupsStatus(e)}
                            required
                          >
                            <option value="">Select Followups Status</option>{" "}
                            {/* Default option */}
                            <option value="Unqualified">Unqualified</option>
                            {/* <option value="Walkin">Walkin</option> */}
                            <option value="Converted">Converted</option>
                            {/* <option value="NotReachable">Not Reachable</option> */}
                          </select>
                          <label
                            className={
                              UpdatedData.followups_status ? "filled" : ""
                            }
                          >
                            Followups Status
                          </label>
                        </div>
                      </div>

                      <div
                        className={`${UpdatedData.followups_status == "Rescheduled"
                          ? "row"
                          : "d-none"
                          }`}
                      >
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              placeholder=""
                              value={
                                UpdatedData.status_date
                                  ? formatDatefitching(UpdatedData.status_date)
                                  : ""
                              }
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_date ? "filled" : ""
                              }
                            >
                              Reschudule Date
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="time"
                              placeholder=""
                              value={UpdatedData.status_time}
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_time: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_time ? "filled" : ""
                              }
                            >
                              Reschudule Time
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`${UpdatedData.followups_status == "Walkin"
                          ? "row"
                          : "d-none"
                          }`}
                      >
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              placeholder=""
                              value={
                                UpdatedData.followups_date
                                  ? formatDatefitching(
                                    UpdatedData.followups_date
                                  )
                                  : ""
                              }
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  followups_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.followups_date ? "filled" : ""
                              }
                            >
                              Visit Date
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="time"
                              placeholder=""
                              value={UpdatedData.status_time}
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  status_time: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                UpdatedData.status_time ? "filled" : ""
                              }
                            >
                              Visit Time
                            </label>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          UpdatedData.followups_status === "Walkin" ||
                            UpdatedData.followups_status === "Rescheduled"
                            ? "row"
                            : "d-none"
                        }
                      >
                        <div className="floating-label">
                          <textarea
                            className="form-control"
                            value={UpdatedData.followups_notes || ""}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                followups_notes: e.target.value,
                              })
                            }
                            required
                          ></textarea>
                          <label
                            className={
                              UpdatedData.followups_notes ? "filled" : ""
                            }
                          >
                            Followups Notes
                          </label>
                        </div>
                      </div>

                      {/* <div>
                        <input
                          type="radio"
                          id="html"
                          classNameame="mx-2"
                          value="Interest"
                          onChange={(e) => interstedHandel(e)}
                        />
                        <label for="html">Interest</label>
                        <br></br>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShow(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={() => handleupdatesubmit(UpdatedData._id)}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Walkin;
